(function () {
  function openDrawer() {
    const drawer = document.getElementById('cart-drawer');
    const backdrop = document.getElementById('cart-drawer-backdrop');
    if (!drawer || !backdrop) return;
    drawer.classList.add('active');
    backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    const drawer = document.getElementById('cart-drawer');
    const backdrop = document.getElementById('cart-drawer-backdrop');
    if (!drawer || !backdrop) return;
    drawer.classList.remove('active');
    backdrop.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Format minor units (cents) → money string mirroring the EXACT Liquid `{{ price | money }}` format.
  // We sniff the current DOM (e.g. "€45,00" or "45,00 €") to detect symbol position and decimal separator,
  // so optimistic updates produce strings byte-identical to the Liquid-rendered output. This prevents
  // visual flashes when a section refresh later replaces the same value.
  let _moneyTemplate = null;
  function detectMoneyTemplate() {
    if (_moneyTemplate) return _moneyTemplate;
    const sample = document.getElementById('cart-total')?.textContent?.trim()
      || document.querySelector('.cart-item h3')?.parentElement?.querySelector('span')?.textContent?.trim();
    if (!sample) return null;
    // Capture: prefix (non-digits), then digits with separator, then suffix
    const m = sample.match(/^([^\d-]*)(-?[\d.,\s ]+)([^\d]*)$/);
    if (!m) return null;
    const numPart = m[2];
    const decSep = numPart.includes(',') && (!numPart.includes('.') || numPart.lastIndexOf(',') > numPart.lastIndexOf('.'))
      ? ',' : '.';
    const thouSep = decSep === ',' ? '.' : ',';
    _moneyTemplate = { prefix: m[1], suffix: m[3], decSep, thouSep };
    return _moneyTemplate;
  }
  function formatMoney(cents) {
    const tpl = detectMoneyTemplate();
    const amount = (cents || 0) / 100;
    if (!tpl) return amount.toFixed(2);
    const [intPart, decPart] = amount.toFixed(2).split('.');
    const intWithThou = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, tpl.thouSep);
    return tpl.prefix + intWithThou + tpl.decSep + decPart + tpl.suffix;
  }

  // Apply optimistic DOM updates from /cart.js JSON response — instant feedback,
  // doesn't depend on Section Rendering API (which has caching/routing quirks).
  function applyCartJson(cart) {
    if (!cart || typeof cart.item_count !== 'number') return;

    // 1. Header badge
    const badge = document.getElementById('cart-count-badge');
    if (badge) {
      badge.textContent = cart.item_count;
      badge.classList.toggle('hidden', cart.item_count === 0);
    }

    // 2. Drawer header count "N ITEM(S) IN YOUR BAG" — pluralize from data-attrs set by Liquid
    const countEl = document.getElementById('cart-drawer-count');
    if (countEl) {
      const singular = countEl.dataset.singular || '';
      const plural = countEl.dataset.plural || '';
      const noun = cart.item_count === 1 ? singular : plural;
      countEl.textContent = cart.item_count + ' ' + noun;
    }

    // 3. Cart total
    const totalEl = document.getElementById('cart-total');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    // 4. Per-line updates: qty + line price; remove element if line dropped
    const presentKeys = new Set((cart.items || []).map(i => i.key));
    document.querySelectorAll('.cart-item').forEach(itemEl => {
      const key = itemEl.dataset.key;
      if (!presentKeys.has(key)) {
        // Line removed — fade out then drop
        itemEl.style.transition = 'opacity 0.2s ease, max-height 0.3s ease, padding 0.3s ease';
        itemEl.style.opacity = '0';
        itemEl.style.maxHeight = '0';
        itemEl.style.padding = '0';
        itemEl.style.margin = '0';
        itemEl.style.overflow = 'hidden';
        setTimeout(() => itemEl.remove(), 300);
        return;
      }
      const line = (cart.items || []).find(i => i.key === key);
      if (!line) return;
      const qtyEl = itemEl.querySelector('.cart-qty-value');
      if (qtyEl) qtyEl.textContent = String(line.quantity);
      // Line price: the {{ item.final_line_price | money }} span next to the title.
      // It's the second child <span> inside the title row — find by selector.
      const priceEl = itemEl.querySelector('h3')?.parentElement?.querySelector('span');
      if (priceEl) priceEl.textContent = formatMoney(line.final_line_price);
    });

    // 5. If cart became empty, hide footer/checkout (full refresh will rebuild empty state)
    if (cart.item_count === 0) {
      const itemsEl = document.getElementById('cart-drawer-items');
      if (itemsEl) itemsEl.innerHTML = '';
    }
  }

  // Full section refresh — rebuilds tier rewards bar, recommendations, free-shipping celebration.
  // The optimistic update above gives instant feedback; this catches up the complex bits.
  async function refreshCartDrawer() {
    try {
      const wasOpen = document.getElementById('cart-drawer')?.classList.contains('active') || false;
      // Use locale-aware path. window.Shopify.routes.root respects Markets locale (e.g. "/fr/").
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = root + '?sections=cart-drawer&_t=' + Date.now();
      const res = await fetch(url, {
        headers: { 'Cache-Control': 'no-cache' },
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!res.ok) throw new Error('section fetch ' + res.status);
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;
      const wrapper = document.getElementById('shopify-section-cart-drawer');
      if (!wrapper) return;
      wrapper.innerHTML = html;

      if (wasOpen) {
        const drawer = document.getElementById('cart-drawer');
        const backdrop = document.getElementById('cart-drawer-backdrop');
        if (drawer) drawer.classList.add('active');
        if (backdrop) backdrop.classList.add('active');
        document.body.style.overflow = 'hidden';
      }
    } catch (e) {
      console.warn('Cart drawer section refresh failed (DOM was already updated optimistically):', e);
    }
  }

  // Tier reward thresholds (cents) — must match cart-drawer.liquid
  const TIERS = [20000, 30000, 45000, 65000];
  function tierBucket(total) {
    let b = 0;
    for (const t of TIERS) if (total >= t) b++;
    return b;
  }

  // Track in-flight cart updates per line key to prevent double-clicks
  const inFlight = new Set();
  let lastKnownTotal = null;
  let lastKnownItemCount = null;

  async function updateCart(key, quantity) {
    if (inFlight.has(key)) return;
    inFlight.add(key);
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      const cart = await res.json();
      // Decide whether we need a full section refresh: only when tier bucket changed
      // (crossing a reward threshold) or when a line was removed (DOM structure changed).
      const prevBucket = lastKnownTotal == null ? tierBucket(cart.total_price) : tierBucket(lastKnownTotal);
      const newBucket = tierBucket(cart.total_price);
      const lineRemoved = lastKnownItemCount != null && cart.items.length < lastKnownItemCount;
      const needsFullRefresh = prevBucket !== newBucket || lineRemoved;

      applyCartJson(cart);
      lastKnownTotal = cart.total_price;
      lastKnownItemCount = cart.items.length;

      if (needsFullRefresh) refreshCartDrawer();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (e) {
      console.error('Cart update failed:', e);
    } finally {
      inFlight.delete(key);
    }
  }

  // Event delegation — handlers survive DOM replacement
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('#cart-drawer-trigger');
    if (trigger) {
      e.preventDefault();
      openDrawer();
      return;
    }
    const closeBtn = e.target.closest('#cart-drawer-close');
    if (closeBtn) { closeDrawer(); return; }
    const backdrop = e.target.closest('#cart-drawer-backdrop');
    if (backdrop) { closeDrawer(); return; }

    // Checkout: if a cart change (e.g. a just-clicked remove) is still in flight,
    // wait for it to commit server-side before navigating, so checkout never loads a stale cart.
    const checkoutBtn = e.target.closest('[data-cart-checkout]');
    if (checkoutBtn && inFlight.size > 0) {
      e.preventDefault();
      const href = checkoutBtn.getAttribute('href') || '/checkout';
      checkoutBtn.style.opacity = '0.6';
      checkoutBtn.style.pointerEvents = 'none';
      (async () => {
        const start = Date.now();
        while (inFlight.size > 0 && Date.now() - start < 3000) {
          await new Promise(r => setTimeout(r, 80));
        }
        window.location.href = href;
      })();
      return;
    }

    const minus = e.target.closest('.cart-qty-minus');
    if (minus) {
      const key = minus.dataset.key;
      const qtyEl = minus.closest('.cart-item').querySelector('.cart-qty-value');
      let qty = parseInt(qtyEl.textContent) - 1;
      if (qty < 0) qty = 0;
      updateCart(key, qty);
      return;
    }
    const plus = e.target.closest('.cart-qty-plus');
    if (plus) {
      const key = plus.dataset.key;
      const qtyEl = plus.closest('.cart-item').querySelector('.cart-qty-value');
      const qty = parseInt(qtyEl.textContent) + 1;
      updateCart(key, qty);
      return;
    }
    const remove = e.target.closest('.cart-remove');
    if (remove) {
      const key = remove.dataset.key;
      const item = remove.closest('.cart-item');
      if (item) item.style.opacity = '0.5';
      updateCart(key, 0);
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Add to Cart forms (intercept) — only for forms NOT already handled by PDP-specific handler
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    if (form.hasAttribute('data-product-form')) return;
    if (form.dataset.submitting === '1') { e.preventDefault(); return; }
    e.preventDefault();
    form.dataset.submitting = '1';
    const formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(r => r.json())
      .then(async () => {
        // For add-to-cart we need full re-render (new line item element to create)
        await refreshCartDrawer();
        openDrawer();
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(err => console.error('Add to cart failed:', err))
      .finally(() => { delete form.dataset.submitting; });
  });

  window.cartDrawer = { open: openDrawer, close: closeDrawer, refresh: refreshCartDrawer };
})();
